/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
import Mail from "@material-ui/icons/Mail";
import Favorite from "@material-ui/icons/Favorite";

import { useDispatch, useSelector } from "react-redux";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

// stepper
import Box from '@material-ui/core/Box';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import {
    infoColor,
} from "assets/jss/material-kit-pro-react.js";

import orderStageOne from "../../../assets/jss/CustomerTradePortal/views/OrderProcessPageSections/orderSageOnePageStyle.js";


export default function stepperPage({stepValue}) {
    
    const orderProcessSteps = useSelector(state => state.userReducer.orderProcessSteps)
    const useStyles = makeStyles(orderStageOne);

    const useStepperStyle = makeStyles(() => ({
        root: {
            backgroundColor: "transparent",
            "& .MuiStepIcon-active": { color: infoColor[1] },
            "& .MuiStepIcon-completed": { color: "green" },
            "& .MuiStepLabel-labelContainer span": { fontSize: '18px' }
            /*      "& .Mui-disabled .MuiStepIcon-root": { color: "cyan" }*/
        },
    }));

    const classes = useStyles();
    const stepclasses = useStepperStyle();

    return (
        <div>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <h2 className={classes.title}>Place an Order </h2>
                    <Box className={classes.boxArea}>
                        <Stepper orientation="horizontal" activeStep={stepValue} className={stepclasses.root}>
                            {orderProcessSteps.map((label) => (
                                <Step key={label} style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}  >
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </Box>
                </GridItem>
            </GridContainer>


        </div>
    );
}
